import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest, Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { setQuestion } from 'src/app/actions/question.actions';
import { Candidate } from 'src/app/models/candidate.model';
import { Question } from 'src/app/models/question.model';
import { Test } from 'src/app/models/test.model';
import { fromCandidate } from 'src/app/reducers/candidate.reducer';
import { fromQuestion } from 'src/app/reducers/question.reducer';
import { fromTest } from 'src/app/reducers/test.reducer';
import { CustomSelectService } from 'src/app/services/customSelect.service';
import { QuestionService } from 'src/app/services/question.service';
import { UtilsService } from 'src/app/services/utils.service';
import Typewriter from 'typewriter-effect/dist/core';

@Component({
  selector: 'ct-digital-instruction',
  templateUrl: './digital-instruction.component.html',
  styleUrls: ['./digital-instruction.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DigitalInstructionComponent implements OnInit {

  @Input() colors: any;

  public question$: Observable<Question>;
  public test$: Observable<Test>;

  public instructionsPageNumber = 0;
  public currentCandidate: Candidate;
  public currentTest: Test;
  public currentLanguage: string;
  public languagesNotSelected: string[];
  public bumbleTexts = [];


  constructor(
    private store: Store,
    private questionService: QuestionService,
    private utilsService: UtilsService,
    private translateService: TranslateService,
    public customSelectService: CustomSelectService
  ) { }

  ngOnInit(): void {

    // obtenemos los datos de la pregunta y el test de la store
    this.test$ = this.store.pipe(select(fromTest.selectTestState));
    this.question$ = this.store.pipe(select(fromQuestion.selectQuestionState));

    this.test$.subscribe(test => {
      if (test) {
        this.currentCandidate = test.candidate;
        this.currentTest = test;
        this.currentLanguage = this.utilsService.getLanguageFromLanguageId(test.invitation.languageId);
        this.translateService.use(this.currentLanguage);
        document.documentElement.lang = this.currentLanguage.split('-')[0];

        combineLatest([
          // corregido para ESFBITE-1342 por pentest para evitar XSS
          this.translateService.get('TEST.26.INSTRUCTIONS.PAGE_7.HELLO', { x: this.utilsService.titlecase(this.currentCandidate.name).replace(/[<>"'&]/g, '') }),
          this.translateService.get('TEST.26.INSTRUCTIONS.PAGE_7.LOADINGTEST'),
          this.translateService.get('TEST.26.INSTRUCTIONS.PAGE_7.STARTINGTEST')
        ]).subscribe(([hello, loadingTest, startTest]) => {
          this.bumbleTexts = [hello.replace(' !', '!'), loadingTest, startTest];
        });
      }
    });

  }

  /**
   * Avanza en las páginas de instrucciones
   */
  public nextInstructionsPage() {
    window.scroll(0, 0);
    // si es la ultima página de instrucciones se pasa al ejemplo de módulo/nivel
    if (this.instructionsPageNumber === 6) {
      this.utilsService.feature = 'digital-test';
      setTimeout(() => {
        this.animations(0);
      }, 500);
    }
    window.scroll(0, 0);

    // si es la ultima página de instrucciones se pasa al test
    if (this.instructionsPageNumber === 7) {
      this.test$.subscribe(test => {
        this.questionService.getNextQuestion(test.token).subscribe(questions => {
          this.store.dispatch(setQuestion(questions));
        });
      });
    } else {
      this.instructionsPageNumber++;
    }
  }

  /**
   * Retrocede en las páginas de instrucciones
   */
  public previousInstructionsPage() {
    this.utilsService.feature = 'digital-instruction';
    window.scroll(0, 0);
    if (this.instructionsPageNumber !== 0) {
      this.instructionsPageNumber--;
    }
  }

  /**
   * cambio de idioma de todas laspruebas del candidato
   */
  public changeLanguage(language) {
    this.utilsService.changeLanguage(language, this.currentCandidate.id).subscribe(res => {
      this.currentLanguage = language;
    });
  }

  /**
   * muestra/oculta el sleccionable de idiomas responsive
   */
  public toogleLanguageSelect(action: string) {
    // actualizamos de los idiomas no seleccionados
    this.languagesNotSelected = this.utilsService.getLanguagesNotSelected(this.currentTest?.clientId);

    // se ejecuta la cción que corresponda
    switch (action) {
      case 'toogle':
        this.customSelectService.toogleLanguageSelect('toogle');
        break;
      case 'false':
        this.customSelectService.toogleLanguageSelect('false');
        break;
      default:
        this.customSelectService.toogleLanguageSelect('toogle');
        break;
    }
  }

  animations(i: number) {
    if (this.instructionsPageNumber !== 7) {
      return;
    }

    const lines = [...document.querySelectorAll('.typewriter')] as HTMLElement[];

    if (lines[i] && this.bumbleTexts[i]) {
      let pause;
      if (i === 0) {
        // Si es la primera iteración esperar un tiempo extra a que termine la animación de los puntos
        pause = 2250;
        setTimeout(() => {
          const thinking = document.querySelector('.thinking') as HTMLElement;
          thinking.style.display = 'none';
          lines[i].style.display = 'block';
        }, pause);
      } else {
        lines[i].style.display = 'block';
        pause = 0;
      }

      const typewriter = new Typewriter(lines[i], { delay: 40 });

      typewriter
        .pauseFor(pause + 500)
        .typeString(this.bumbleTexts[i])
        .pauseFor(500)
        .start()
        .callFunction(() => {
          const cursors = [...document.querySelectorAll('.Typewriter__cursor')] as HTMLElement[];
          if (cursors[i]) {
            cursors[i].style.display = 'none';
          }
          this.animations(i + 1);
        });
    } else {
      setTimeout(() => {
        if (this.instructionsPageNumber === 7) {
          this.nextInstructionsPage();
        }
      }, 2000);
    }
  }

}
